import { DeleteOutlined } from "@ant-design/icons";
import { Button, Checkbox, CheckboxProps, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";

type Props = {
  open?: any;
  isCloseModal?: any;
  user?: any;
};

const EmployeeModal: React.FC<Props> = ({
  open,
  isCloseModal,
  user,
}: Props) => {
  const [name, setName] = useState<string>("");
  const [job, setJob] = useState<string>("");

  useEffect(() => {
    if (user) {
      setName(user?.name);
      setJob(user?.subs);
    }
  }, [user]);

  const handleInputName = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setName(event.target.value);
  };

  const handleInputJob = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setJob(event.target.value);
  };

  const closeModal = (isOpen: boolean) => {
    isCloseModal();
  };

  const onChange: CheckboxProps["onChange"] = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <Modal
      title={`${!user ? "Добавить" : "Редактировать"} сотрудника`}
      open={open}
      onCancel={() => closeModal(false)}
      footer={
        user?.name
          ? [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                <DeleteOutlined />
                Удалить
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                Сохранить
              </Button>,
            ]
          : [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                Сохранить
              </Button>,
            ]
      }
    >
      <p>ФИО сотрудника</p>
      <Input
        type="text"
        placeholder="Введите ФИО сотрудника полностью"
        value={name}
        name="name"
        onChange={handleInputName}
      />
      <p>Должность сотрудника</p>
      <Input
        type="text"
        placeholder="Введите должность сотрудника полностью"
        value={job}
        name="job"
        onChange={handleInputJob}
      />
      {!user && (
        <>
          <p>Выберите отдел</p>
          <div className="flex">
            <Select
              style={{ width: 200 }}
              allowClear={false}
              options={[
                { value: "Руководство" },
                { value: "Отдел маркетинга" },
                { value: "Отдел ИТ" },
                { value: "Бухгалтерия" },
                { value: "Склад" },
              ]}
              placeholder="Отдел сотрудника"
              showSearch
            />
            <Checkbox onChange={onChange}>
              Является руководителем отдела
            </Checkbox>
          </div>
        </>
      )}
    </Modal>
  );
};

export default EmployeeModal;
